import { useTranslation } from 'react-i18next';
import type { CaseStatus } from '../api/types';
import { ALL_STATUSES, statusTone } from '../lib/status';

export function StatusPill({ status }: { status: CaseStatus }) {
  const { t } = useTranslation();
  return <span className={`pill ${statusTone(status)}`}>{t(`status.${status}.label`)}</span>;
}

export function Progress({ status }: { status: CaseStatus }) {
  return (
    <div className={`prog ${statusTone(status)}`} aria-hidden="true">
      {ALL_STATUSES.map((k) => (
        <i key={k} className={k <= status ? 'on' : ''} />
      ))}
    </div>
  );
}
